<template>
  <div>
    <Navbar></Navbar>

    <div class="container mt-3 mt-lg-5">

      <!-- TITLE-->
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="overline text-primary mb-1">Liked</p>
          <vue-aos animation-class="animate__animated animate__flipInX">
            <h1 class="typography-headline-lg fw-500">Palettes</h1>
          </vue-aos>
        </div>
      </div>

      <!-- NEW PALETTES SECTION -->
      <div v-if="!palettes || (palettes && palettes.length < 1)" class="col-md-12 text-center mt-3">
        <EmptyState title="You haven't liked anything"
                    subtitle="Explore some palettes and like them to see them here"
                    btnLink="/palettes" btnText="Go to palettes">
        </EmptyState>
      </div>
      <PalettesList :palettes="palettes" :isDisplay="'d-none'"></PalettesList>

      <!-- PAGINATION SECTION -->
      <div v-if="!palettes || (palettes && palettes.length > 11)" class="row mb-3">
        <div class="col-md-12 text-center mb-3">
          <button class="btn btn-default btn-round btn-micint-rotate ripple ripple-dark py-3 px-5"
                  @click="loadMorePalettes">Load more
            palettes
            <i class="material-icons-outlined ms-2">cached</i>
          </button>
        </div>
      </div>

    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import {mapGetters} from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
import PalettesList from "@/components/palettes/PalettesList";
import EmptyState from "@/components/empty-states/EmptyState";
import VueAos from 'vue-aos'

export default {
  name: 'PalettesLiked',
  metaInfo: {
    title: 'Liked Palettes'
  },
  components: {EmptyState, PalettesList, Footer, Navbar, VueAos},
  computed: {
    ...mapGetters(['user'])
  },
  data() {
    return {
      palettes: [],
      db: firebase.firestore(),
      lastPalette: null,
    }
  },
  mounted() {
    this.fetchPalettes()
  },
  methods: {
    async fetchPalettes() {
      try {
        let palettesSnap = this.db
            .collection('users').doc(this.user.data.uid).collection('likedPalettes')

        palettesSnap = await palettesSnap
            .orderBy('createdAt', "desc")
            .limit(12)
            .get()

        this.lastPalette = palettesSnap.docs[palettesSnap.docs.length - 1]
        this.palettes = palettesSnap.docs.map(doc => {
          return {id: doc.id, ...doc.data()}
        })

      } catch (e) {
        console.log(e.message)
      }
    },
    async loadMorePalettes() {
      try {
        let palettesSnap = this.db
            .collection('users').doc(this.user.data.uid).collection('likedPalettes')

        if (this.keywordValue) {
          palettesSnap = palettesSnap
              .where('colorKeywords', 'array-contains', this.keywordValue)
        }

        palettesSnap = await palettesSnap
            .orderBy('createdAt', "desc")
            .limit(12)
            .startAfter(this.lastPalette)
            .get()

        this.lastPalette = palettesSnap.docs[palettesSnap.docs.length - 1]

        palettesSnap.forEach(doc => {
          this.palettes.push({id: doc.id, ...doc.data()})
        })

      } catch (e) {
        console.log(e.message)
      }
    },
  }
}
</script>